<div *ngIf="!mostrarFormulario">
    <app-lfsa-card [innTemplate]="carga" [titulo]="titulo" [efecto]="true" [colapseName]="'carga'"
      [banderaColapse]='false' [optionsExport]="true" (devolverAccion)="downloadCsvFormato()">
    </app-lfsa-card>
    <ng-template #carga>
        <div> USUARIO ACTUAL : {{this.usuario}} </div>
      <hr>
      
      <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">

          <div class="form-group col">
            <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Año'" [label]="'Año *'" 
            [id]="'anio'" formControlName="anio" [control]="formulario.get('anio')">
            </app-lfsa-input>
            <span class="'letrasDanger'" >Año obligatorio</span>
          </div>
<!-- 
          <div class="form-group col">
            <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
              [comboBox]="cmbxMeses" formControlName="mes" [control]="formulario.get('mes')" [label]="'Seleccione Mes *'" [id]="'mes'">
            </app-lfsa-combo-box>
            <span class="'letrasDanger'" >Mes obligatorio</span>
          </div>
-->
          <div class="form-group col">
            <img *ngIf="true" [src]="csv" height="35" width="35" alt="">&nbsp;
            <label for="csvInput" class="letrasDanger">{{ titulo }}.csv*</label>
            <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput
              accept=".csv" />
          </div>
          
          <div class="form-group col">
            <label for="">&nbsp;</label>
            <button [disabled]="formulario.invalid || loading" (click)="enviarFormulario()"
              class="zatras btn btn-success btn-block">Procesar</button>
          </div>

        </div>
  
        <div class="form-group col-md-12">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        </div>  
      </form>

      <br>
      <br>
      <br>
    </ng-template>
  </div>
  
  <div *ngIf="mostrarFormulario">
    <app-lfsa-card [innTemplate]="grid" [titulo]="'CARGAR DE ARCHIVO'" [efecto]="true" [colapseName]="'grid'"
      [banderaColapse]='false' [optionsExport]="true" (devolverAccion)="downloadDataCsv()">
    </app-lfsa-card>

    <ng-template #grid>
      <div class="alert alert-danger" role="alert" *ngIf="listaVacia"> No existen datos para la lista. </div>
      <br>
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" class="{{modulo.agGrid.class}}" [floatingFilter]="true"
        [frameworkComponents]="frameworkComponents" id="{{modulo.agGrid.id}}" [columnDefs]="columnDefs"
        [rowSelection]="rowSelection" [ngStyle]="modulo.agGrid.style" [paginationPageSize]="modulo.agGrid.paginacion"
        [pagination]="true" [rowData]="rowData">
      </ag-grid-angular>
    </ng-template>

    <div class="row">
      <div class="form-group col-md-12"><app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2></div>

      <div class="form-group col-md-6">
        <button (click)="regresar()" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
      </div>

      <div class="form-group col-md-6">
        <button [disabled]="errorData" (click)="guardar()"
          class="btn btn-outline-success btn-block btn-lg">Guardar</button>
      </div>
    </div>

    <br><br>

  </div>